export default "__VITE_ASSET__Dfm1dfNJ__"